import React, { createContext, useContext, useMemo } from "react";

type ContextState = {
  notifications: Notification[];
};

type Notification = {
  audience: "user" | "actor";
  html: string;
};

const SystemContext = createContext<ContextState | undefined>(undefined);

export function SystemProvider({
  notifications,
  children,
}: {
  notifications: Notification[];
  children: React.ReactNode;
}) {
  const memoizedValue = useMemo(() => {
    return {
      notifications,
    };
  }, [notifications]);

  return <SystemContext.Provider value={memoizedValue}>{children}</SystemContext.Provider>;
}

export function useSystem() {
  const context = useContext(SystemContext);
  if (context === undefined) {
    throw new Error("useSystem must be used within a SystemProvider");
  }

  return context;
}
